import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import axios from "axios";

const API_URL = "/api";

const PermissionContext = createContext(null);

export function PermissionProvider({ children }) {
  const [permissions, setPermissions] = useState([]);
  const [role, setRole] = useState("");
  const [loadingPermissions, setLoadingPermissions] =
    useState(true);

  const refreshPermissions = useCallback(async () => {
    const token = localStorage.getItem("company_token");

    if (!token) {
      setPermissions([]);
      setRole("");
      setLoadingPermissions(false);
      return;
    }

    setLoadingPermissions(true);

    try {
      const response = await axios.get(
        `${API_URL}/permissions/me`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setPermissions(response.data.permissions || []);
      setRole(response.data.role || "");
    } catch {
      setPermissions([]);
      setRole("");
    } finally {
      setLoadingPermissions(false);
    }
  }, []);

  useEffect(() => {
    refreshPermissions();
  }, [refreshPermissions]);

  const value = useMemo(
    () => ({
      permissions,
      role,
      loadingPermissions,
      refreshPermissions,

      can: (permissionCode) =>
        role === "superadmin" ||
        permissions.includes(permissionCode),
    }),
    [
      permissions,
      role,
      loadingPermissions,
      refreshPermissions,
    ]
  );

  return (
    <PermissionContext.Provider value={value}>
      {children}
    </PermissionContext.Provider>
  );
}

export function usePermissions() {
  const context = useContext(PermissionContext);

  if (!context) {
    throw new Error(
      "usePermissions debe usarse dentro de PermissionProvider."
    );
  }

  return context;
}